import React, { FC, useMemo } from 'react';
import styles from './Header.scss';
import { HeaderLogo } from './HeaderLogo';
import { HeaderProgress } from './HeaderProgress';
import { useFlowContext } from 'context/FlowProvider';
import { useOrchestratorState } from '@wix/gg-common-lib/orchestrator';
import { HeaderProgressCounter } from './HeaderProgressCounter';
import { useIsMobile } from '@wix/gg-common-lib/hooks';
import clsx from 'clsx';

export const Header: FC = () => {
  const { currentStep } = useOrchestratorState();
  const { steps } = useFlowContext();
  const isMobile = useIsMobile();

  const filteredSteps = useMemo(
    () => steps.filter((step) => step.params?.hideProgress !== true && !step.params?.countInProgress),
    [steps],
  );

  const currentStepIndex = useMemo(() => {
    const stepId = currentStep?.params?.countInProgress ?? currentStep?.id;
    return filteredSteps.findIndex((step) => step.id === stepId) + 1;
  }, [filteredSteps, currentStep?.id, currentStep?.params?.countInProgress]);

  const shouldShowProgress = useMemo(
    () => currentStep?.params?.hideProgress !== true,
    [currentStep?.params?.hideProgress],
  );

  if (isMobile) {
    return (
      <div className={styles.headerMobile}>
        <div className={clsx(styles.header, shouldShowProgress && styles.removePaddingBottom)}>
          <HeaderLogo />
          {shouldShowProgress && (
            <HeaderProgressCounter currentStepIndex={currentStepIndex} totalSteps={filteredSteps.length} />
          )}
        </div>
        {shouldShowProgress && (
          <div className={styles.headerMobileProgress}>
            <HeaderProgress currentStepIndex={currentStepIndex} totalSteps={filteredSteps.length} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.header}>
      <HeaderLogo />
      {shouldShowProgress && (
        <div className={styles.headerProgressContainer}>
          <HeaderProgress currentStepIndex={currentStepIndex} totalSteps={filteredSteps.length} />
          <HeaderProgressCounter currentStepIndex={currentStepIndex} totalSteps={filteredSteps.length} />
        </div>
      )}
    </div>
  );
};
